import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = guest, obj = user
  const [token, setToken] = useState(localStorage.getItem("cbs_token") || null);

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem("cbs_token");
    if (!t) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("cbs_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const persist = (data) => {
    localStorage.setItem("cbs_token", data.token);
    setToken(data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      persist(data);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatError(e.response?.data?.detail) };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      persist(data);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatError(e.response?.data?.detail) };
    }
  };

  const logout = () => {
    localStorage.removeItem("cbs_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
